import React, { useState } from "react";
import FullButton from "../components/Buttons/FullButton";
import {
  Container,
  Form,
  FormWrapper,
  Input,
  Message,
  PageWrapper,
  StatusMessage,
  Wrapper,
} from "../style/view.styles";
import { useNavigate } from "react-router-dom";

export default function RequestResetPassword() {
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setFormStatus({
        message: "Please enter your email address",
        type: "error",
      });
      return;
    }

    setLoading(true);
    setFormStatus({
      message: "",
      type: "success",
    });

    try {
      const appUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${appUrl}/new/otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_email: email,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setFormStatus({
          message: "Reset instructions sent! Check your email for the OTP code.",
          type: "success",
        });
        setTimeout(() => {
          navigate("/reset-password", { state: { email } });
        }, 2000);
      } else {
        setFormStatus({
          message: data.result || "Failed to process request. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setFormStatus({
        message: "Something went wrong. Please try again later.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <PageWrapper className="container flexCenter">
            <FormWrapper>
              <h1 className="extraBold font40 darkGreenColor">Forgot Password</h1>
              <p className="font16" style={{ textAlign: "center", margin: "20px 0" }}>
                Enter your email address to receive a verification code
              </p>
              <Form onSubmit={handleSubmit}>
                <Input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={handleInputChange}
                  required
                />
                <FullButton disabled={loading} title={loading ? "Sending..." : "Send Reset Code"} />
              </Form>
              {formStatus.message && (
                <StatusMessage type={formStatus.type}>
                  {formStatus.message}
                </StatusMessage>
              )}
              <Message className="font13">
                Remember your password? <a href="/login">Login here</a>
              </Message>
              <Message className="font13">
                Don't have an account? <a href="/register">Register here</a>
              </Message>
            </FormWrapper>
          </PageWrapper>
        </Container>
      </Wrapper>
    </>
  );
}